export default {"src":"/_next/static/media/java_vertical_logo_8957434553.be5a9b2d.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};